import React from 'react';
import classnames from 'classnames/bind';
import Label from '../Label';
import FieldErrors from '../FieldErrors';

import styles from './styles.scss';

export default class Input extends React.Component {

    _isCheckbox() {
        return this.props.type === 'checkbox';
    }

    _isRadioButton() {
        return this.props.type === 'radio';
    }

    _getInputClassNames() {
        const cx = classnames.bind(styles);

        return cx({
            'input': true,
            'input--checkbox': this._isCheckbox(),
            'input--radio': this._isRadioButton(),
            'input--error': this.props.meta.invalid
        });
    }

    _getLabelClassNames() {
        const cx = classnames.bind(styles);

        return cx({
            'label--checkbox': this._isCheckbox(),
            'label--radio': this._isRadioButton(),
            'label--radio_disabled': this._isRadioButton() && this.props.disabled
        });
    }

    render() {

        // Filter out props supplied by react-redux-form Field component
        const { label, required, input, meta: { touched, error }, ...allProps } = this.props;

        const inputId = `${input.name}_input`;

        return (
            <div>
                <Label text={label} className={this._getLabelClassNames()} htmlFor={this.props.id || inputId} required={required}>
                    <input
                        {...input}
                        {...allProps}
                        className={this._getInputClassNames()}
                        id={this.props.id || inputId}
                        aria-required={required}
                    />

                    {this._isCheckbox() && <div></div>}

                    {this._isCheckbox() && <span className={styles.checkbox}>&nbsp;</span>}
                    {this._isRadioButton() && <span className={styles.radio}>&nbsp;</span>}
                </Label>

                {touched && error && <FieldErrors errors={error} />}
            </div>
        )
    }
}